import React from 'react';

export default function RocketBlock() {
  return (
    <svg
      width='42'
      height='41'
      viewBox='0 0 42 41'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g filter='url(#filter0_di_4454_82959)'>
        <g clip-path='url(#clip0_4454_82959)'>
          <rect
            x='1'
            width='40'
            height='40'
            rx='12'
            fill='url(#paint0_linear_4454_82959)'
          />
          <g
            clip-path='url(#clip1_4454_82959)'
            filter='url(#filter1_dd_4454_82959)'
          >
            <path
              d='M11.7508 23H8.99977V22C8.98464 20.5979 9.35597 19.2187 10.073 18.0137C10.7901 16.8087 11.8252 15.8245 13.0648 15.169C14.2859 14.5669 15.6084 14.1973 16.9648 14.079C16.3721 14.8123 15.7778 15.5917 15.1818 16.417C13.8394 18.5019 12.6909 20.7055 11.7508 23ZM24.5828 25.813C22.4981 27.1571 20.2945 28.3073 17.9998 29.249V32H18.9998C20.4019 32.0151 21.7811 31.6438 22.9861 30.9267C24.1911 30.2097 25.1753 29.1746 25.8308 27.935C26.4329 26.7139 26.8025 25.3914 26.9208 24.035C26.1908 24.625 25.4114 25.2177 24.5828 25.813ZM32.9998 10.991C32.8668 15.344 29.7328 19.661 23.4178 24.191C21.6993 25.305 19.8863 26.2661 17.9998 27.063V26.5C17.9953 25.5731 17.6251 24.6855 16.9697 24.0301C16.3143 23.3747 15.4267 23.0045 14.4998 23H13.9368C14.7347 21.1135 15.6971 19.3008 16.8128 17.583C21.3318 11.278 25.6418 8.144 29.9878 8C32.1538 8 32.9998 8.885 32.9998 10.991ZM26.9998 16.5C26.9998 15.837 26.7364 15.2011 26.2675 14.7322C25.7987 14.2634 25.1628 14 24.4998 14C23.8367 14 23.2008 14.2634 22.732 14.7322C22.2632 15.2011 21.9998 15.837 21.9998 16.5C21.9998 17.163 22.2632 17.7989 22.732 18.2678C23.2008 18.7366 23.8367 19 24.4998 19C25.1628 19 25.7987 18.7366 26.2675 18.2678C26.7364 17.7989 26.9998 17.163 26.9998 16.5ZM10.3738 31.785C11.4998 31.585 14.2148 31.027 15.1218 30.121C15.4004 29.8424 15.6214 29.5117 15.7721 29.1476C15.9229 28.7836 16.0005 28.3935 16.0005 27.9995C16.0005 27.6055 15.9229 27.2154 15.7721 26.8514C15.6214 26.4873 15.4004 26.1566 15.1218 25.878C14.8432 25.5994 14.5124 25.3784 14.1484 25.2276C13.7844 25.0769 13.3943 24.9992 13.0003 24.9992C12.2046 24.9992 11.4414 25.3153 10.8788 25.878C9.97277 26.785 9.41377 29.5 9.21477 30.626L8.96777 32.032L10.3738 31.785Z'
              fill='url(#paint1_linear_4454_82959)'
            />
          </g>
        </g>
      </g>
      <defs>
        <filter
          id='filter0_di_4454_82959'
          x='0.5'
          y='0'
          width='41'
          height='41'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'
        >
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='0.5' />
          <feGaussianBlur stdDeviation='0.25' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_4454_82959'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_4454_82959'
            result='shape'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='0.5' />
          <feGaussianBlur stdDeviation='0.25' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0'
          />
          <feBlend
            mode='normal'
            in2='shape'
            result='effect2_innerShadow_4454_82959'
          />
        </filter>
        <filter
          id='filter1_dd_4454_82959'
          x='-21'
          y='-18.1015'
          width='84'
          height='84'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'
        >
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='10' />
          <feGaussianBlur stdDeviation='10' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.118924 0 0 0 0 0.158031 0 0 0 0 0.570833 0 0 0 0.4 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_4454_82959'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='3.89851' />
          <feGaussianBlur stdDeviation='15' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0'
          />
          <feBlend
            mode='normal'
            in2='effect1_dropShadow_4454_82959'
            result='effect2_dropShadow_4454_82959'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect2_dropShadow_4454_82959'
            result='shape'
          />
        </filter>
        <linearGradient
          id='paint0_linear_4454_82959'
          x1='21'
          y1='0'
          x2='21'
          y2='40'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#29282C' />
          <stop offset='1' stop-color='#100F11' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_4454_82959'
          x1='8.78209'
          y1='3.06221'
          x2='26.2276'
          y2='28.633'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' />
          <stop offset='1' stop-color='white' stop-opacity='0.65' />
        </linearGradient>
        <clipPath id='clip0_4454_82959'>
          <rect x='1' width='40' height='40' rx='12' fill='white' />
        </clipPath>
        <clipPath id='clip1_4454_82959'>
          <rect
            width='24'
            height='24'
            fill='white'
            transform='translate(9 8)'
          />
        </clipPath>
      </defs>
    </svg>
  );
}
